import WasmController from "react-lib/frameworks/WasmController";
import PaySlipList from "issara-sdk/apis/PaySlipList_apps_HRM";
import PaySlipSerializer from "issara-sdk/types/PaySlipSerializer_apps_HRM";
import { SetProperty } from "../../common/CommonInterface";

export type PaySlipApiType = Partial<{
  id: number;
  employee: number;
  employee_pre_name: string | null;
  employee_first_name: string;
  employee_last_name: string;
  employee_full_name: string;
  employee_code: string;
  employee_department: string;
  employee_position: string;
  salary: string;
  overtime: string;
  bonus: string;
  doctor_fee: string;
  providence_fund: string;
  absence: string;
  with_holding_tax: string;
  social_security_fund: string;
  total_revenue: string;
  total_deduct: string;
  net_salary: string;
  bank_short_name: string | null;
  salary_pay_run: number | null;
  cycle_date_start: string | null;
  cycle_date_end: string | null;
  payment_date: string | null;
  ytd_earning: any;
  accumulated_ssf: any;
  ytd_with_holding_tax: any;
  accumulated_provident_fund: any;
  current_year: any;
  language_score: string;
  skill_score: string;
  send_to_payroll_date: string;
  bank_account_no: string;
  bank_account_name: string;
  payroll_items: any;
  tax_type: number | null;
  current_employee_position: number | null;
  bank: number | null;
  payroll_record: number | null;
}>;

export type State = Partial<{
  PaySlipSequence: Partial<{
    sequenceIndex: "Start" | "Action" | null;
    paySlipList: PaySlipApiType[];  // <-- Added this property
  }> | null;
}>;

export type PickedState = {}; // Add if needed, or leave empty

export type Props = {};

export type RunSequence = <P extends any>(params: P) => void;
export type SetProp = SetProperty<State & PickedState>;

export const StateInitial: State = {
  PaySlipSequence: {
    sequenceIndex: null,
    paySlipList: [],
  },
};

export type Event =
  | { message: "RunSequence"; params: any }
  | { message: "GetMasterData"; params: any };

export type Data = {
  division?: number;
};

export const DataInitial: Data = {};

export const ACTIONS = {
  FETCH: "FETCH",
} as const;

export const BTN_ACTS = {
  FETCH: "CardSelfServicePaySlip_FETCH",
};

type Handler<P = any, R = any> = (
  controller: WasmController<State & PickedState, Event, Data, Props>,
  params: P
) => R;

export const Start: Handler = async (controller, params) => {
  const state = controller.getState();
  console.log("Sequence Start called with params:", params);

  controller.setState(
    {
      PaySlipSequence: {
        ...state.PaySlipSequence,
        sequenceIndex: "Action",
      },
    },
    () => Action(controller, { ...params, action: ACTIONS.FETCH })
  );
};

export const Action: Handler<{ action: keyof typeof ACTIONS; start_date?: string; end_date?: string }> = async (
  controller,
  params
) => {
  if (params.action === ACTIONS.FETCH) {
    await HandleFetchPaySlip(controller, params);
  }
};

const HandleFetchPaySlip: Handler<{ start_date?: string; end_date?: string }> = async (
  controller,
  params
) => {
  const state = controller.getState();
  console.log("Log handle fetch")

  const [result, err] = await GetPaySlipList(controller, params);

  if (err) {
    // handle error as you want, e.g. set error state or log
    console.error("Fetch PaySlip failed", err);
    return;
  }

  controller.setState({
    PaySlipSequence: {
      ...state.PaySlipSequence,
      paySlipList: result?.items ?? [],
      sequenceIndex: "Action",
    },
  });
};

const GetPaySlipList: Handler<{ start_date?: string; end_date?: string }> = async (
  controller,
  params
) => {
  // Pass start_date and end_date as query params to the API
  const apiParams: any = {};
  if (params.start_date) apiParams.start_date = params.start_date;
  if (params.end_date) apiParams.end_date = params.end_date;

  const [resp, err] = await PaySlipList.list({
    apiToken: controller.apiToken,
    params: apiParams,
    extra: {
      division: controller.data.division,
    },
  });

  console.log("Pay Slip Respone: ", resp)

  return [resp, err];
};